export class IntersectionData {
  public id: number;
  public siterecordCharacteristicsExtendedId: number;
  public intersectionDataOrder: number;
  public trafficlightSignalGroup: string;
  public specificLaneComposition: string; // SpecificLaneCompositionType
  public trafficSortingCharacteristics: string; // TrafficSortingCharacteristicsType;
}



// WEBPACK FOOTER //
// ./src/app/models/intersectionData.model.ts